import api from './api'

const empresaService = {}

empresaService.consultar = async function() {
    return api.get('/Empresa/').then(res => res.data);
}

export default empresaService